import React, {useCallback} from 'react';
import {useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';

import {Button} from '@material-ui/core';

import {selectUserinfo} from 'aauth/ducks/jsonapi';

import {url_for} from 'aauth/components/Router';
import {useApi} from 'aauth/components/Api';

function AuthInfoAuthorized({userinfo}) {
    const api = useApi();
    const history = useHistory();

    const logout = useCallback(async () => {
        await api.logout();
        history.push(url_for('home'));
    }, [api, history]);

    const logoutAll = useCallback(async () => {
        await api.logout({revoke_all: true});
        history.push(url_for('home'));
    }, [api, history]);

    return (
        <span>Logged in as {userinfo.name} 
            <Button color="inherit" onClick={logout}>(logout)</Button>
            <Button small color="inherit" onClick={logoutAll}>(logout all sessions)</Button>
        </span>
    );
}

function AuthInfoAnonymous() {
    return <span>You are not logged in</span>
}

export default function AuthInfo() {
    const userinfo = useSelector(selectUserinfo);
        
    return (
        userinfo
            ? <AuthInfoAuthorized userinfo={userinfo}/>
            : <AuthInfoAnonymous />
    );
}
